<template>
  <v-dialog v-model="dialog" persistent max-width="1000px" :fullscreen="x_mobile ? true : false"   >
    <v-card-title >
        <span class="font-24 w-600 text-00A99D">PDF</span>
        <v-spacer></v-spacer>
        <v-btn icon color="#00A99D" @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text class="pt-8" style="background-color: #777676; position: relative;">
        <div class="PDFsize" style="background-color: #777676;" >
          <pdf v-for="i in numPages"
          :key="i"
          :src="pdfsrc"
          :page="i"
          style="width: 100%; margin-top: 10px;"
          ></pdf>
          
      </div>
      <div style="position: sticky; bottom: 20px; text-align: end">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2"
                  fab
                  dark
                  color="#00A99D"
                  @click="print()"
                >
                  <v-icon dark>
                    mdi-printer-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>พิมพ์</span>
            </v-tooltip>
            
          </div>
      
          
      </v-card-text>
  </v-dialog>
</template>

<script>
import printJS from 'print-js';
import pdf from 'vue-pdf-signature';
export default {
  components: {
    pdf,
  },
  data() {
    return {
      dialog: false,
      nav: null,
      numPages: undefined,
      pdfsrc: null,
      base64: "",
      index: '',
      index2: '',
    }
  },
  computed: {
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 820) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      }
    },
  },
  methods: {
    openDialog(item, value, index, index2) {
      this.index = index
      this.index2 =index2
      this.getPDF(item, value, index, index2)
    },
    closeDialog() {
      this.base64 = ""
      this.dialog = false;
      this.$emit("loading", {index: this.index, index2: this.index2})
    },
    async getPDF(item, value, index, index2) {
      // console.log("index", index);
      // console.log("index2", index2);
      // console.log("getPDF", item);
      // console.log("value", value);
      try {
        var params = new URLSearchParams()
        params.append('biz_id', item.biz_id)
        params.append('template_id', value.template_id)

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/houseVisitPDF_multi?${params}`,
        ).then(async (res) => {
          console.log('province',res);
          if (res.status == 200) {
            
            this.base64 = res.data.data
            this.pdfsrc = await pdf.createLoadingTask('data:application/pdf;base64,'+ res.data.data);
            this.pdfsrc.promise.then(pdf => {
            this.numPages = pdf.numPages;
            this.$emit("loading", {index: index, index2: index2})
            this.dialog = true
           });
          } else {
            this.$emit("loading", {index: index, index2: index2})
          }
        });
      } catch (err) {
        this.$emit("loading", {index: index, index2: index2})
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    print() {
       printJS({printable: this.base64, type: 'pdf', base64: true})
    },
  }
}
</script>

<style scoped>
::v-deep .v-input--selection-controls__input + .v-label {
  font-size: 18px !important;
  color: #333333 !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #313b41;
}

::v-deep .v-input--is-disabled > .v-input__control > .v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-toolbar__content {
  justify-content: center;
}

.text-red {
  color: red;
}

.container {
  max-width: 100%;
  max-height: 700px;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0px;
}
.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-dialog {
  background-color: white !important;
}

.PDFsize {
  padding-left: 30px;
  padding-right: 30px;
}
</style>